import React from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import FooterCommonLogin from "./footerCommonLogin";

const accent = "#3A1C73";
const border = "#E4E4E4";
const subdued = "#9E9E9E";

const categoriesData = {
  "power-cable": {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Safety Clearance from Directorate of Electricity",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  "ofc-telecom": {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Copy of Department of Telecommunications (DOT) licence",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  towers: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Safety Clearance from Directorate of Electricity",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  ducts: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  "natural-gas": {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Safety Clearance from Chief controller of Explosives, Petroleum and Explosives Safety Organization (PESO)",
      "Safety Clearance from Oil Industry Safety Directorate",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  sewage: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Safety Clearance from state / central Pollution Control Board",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  water: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route index plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  repeater: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Copy of Department of Telecommunications (DOT) licence",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route index plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  conveyor: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Safety Clearance from Directorate of Electricity",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route index plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  },
  pumping: {
    documents: [
      "Organization Profile",
      "Document of Power of Attorney in favour of authorized signatory OR Letter of Authorization in case of Government Department.",
      "The License details for operation of the Utilities from Concerned Department/ Letter of Award",
      "Detailed Feasibility Report prepared by the Applicant for accommodation of the Utility Services",
      "The details of Utility identified through Call Before you Dig (CBuD) App.",
      "Methodology for accommodation/ laying of proposed utility services",
      "Methodology for restoration of the Highway and Restoration Plan",
      "Muck Disposal and Management Plan (Optional)",
      "Safety Clearance from Directorate of Electricity",
      "Safety Clearance from Chief controller of Explosives, Petroleum and Explosives Safety Organization (PESO)",
      "Safety Clearance from Oil Industry Safety Directorate",
      "Safety Clearance from state / central Pollution Control Board",
      "Any Other Statutory Clearance or Documents as applicable (Optional)",
      "Circle Rate Certificate",
      "Document for special arrangements made by the applicant below the bed of the structure.",
      "Document to be attached showing calculation of license fee in accordance with Ministry's Guideline No. NH/36094/01/2022/S&R(PB) dated 17 April, 2023."
    ],
    drawings: [
      "Certified copy of strip plan showing details of location of proposed utility, NH ROW, existing structure, other important highway assets.",
      "Route index plan along the Highway showing following: a. Existing ROW of NH land. In yellow colour. | b. Cable / pipe in red colour.",
      "Detailed alignment plan showing Chainage of NHs, Cross Sections, NH ROW, important mile stone, intersections, cross drainage works etc.",
      "Detailed Cross Section of the proposed casing pipe/ducts/ Protection pipe/ conduits and proposed cross section of NH with details of existing and instant utility services"
    ]
  }
};

const categories = [
  {
    id: "power-cable",
    title: "ROW – Industrial & Public Utility - Power Cable",
    count: 13
  },
  {
    id: "ofc-telecom",
    title: "ROW – Industrial & Public Utility - OFC & Telecom Cables",
    count: 13
  },
  {
    id: "towers",
    title: "ROW – Industrial & Public Utility - Towers",
    count: 13
  },
  {
    id: "ducts",
    title: "ROW – Industrial & Public Utility - Ducts",
    count: 11
  },
  {
    id: "natural-gas",
    title:
      "ROW – Industrial & Public Utility - Natural Gas, Gas Pipelines/ CNG/PNG",
    count: 14
  },
  {
    id: "sewage",
    title: "ROW – Industrial & Public Utility - Sewage Pipeline",
    count: 13
  },
  {
    id: "water",
    title: "ROW – Industrial & Public Utility - Water Pipeline",
    count: 11
  },
  {
    id: "repeater",
    title: "ROW – Industrial & Public Utility - Repeater & Junction Box",
    count: 13
  },
  {
    id: "conveyor",
    title: "ROW – Industrial & Public Utility - Conveyor Belts",
    count: 13
  },
  {
    id: "pumping",
    title:
      "ROW – Industrial & Public Utility - Pumping/ Booster stations/ Maintenance Bay",
    count: 16
  }
];

const DocListRightofWayPermission: React.FC = () => {
  const [activeIndex, setActiveIndex] = React.useState<number>(0);

  const activeCategory = categories[activeIndex];
  const activeData =
    categoriesData[activeCategory.id as keyof typeof categoriesData];

  return (
    <>
      {/* Hero / Banner */}
      <Box
        sx={{
          backgroundImage: `linear-gradient(rgba(15,23,42,0.55), rgba(15,23,42,0.10)), url(${require("@assets/images/common-login-bg.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: { xs: 120, md: 140 },
          display: "flex",
          alignItems: "center"
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            width: "100%",
            maxWidth: "100%",
            px: { xs: 2, md: 6 },
            py: { xs: 4, md: 6 }
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "#FFF",
              fontWeight: 800,
              fontSize: { xs: 24, md: 32 },
              lineHeight: 1.25
            }}
          >
            Document List for Right of Way Permission
          </Typography>
        </Container>
      </Box>

      {/* Content */}
      <Box sx={{ bgcolor: "#FFFFFF" }}>
        <Container maxWidth={false} disableGutters sx={{
          width: "100%",
          maxWidth: "100%",
          px: { xs: 2, md: 6 },
          py: { xs: 2 }
        }}>

          {/* ===== SECTION 1: Required Details ===== */}
          <Typography variant="h3" sx={{ mb: 2, fontWeight: "700", pt: 2, fontSize: { xs: "1.8rem", md: "2.5rem" } }}>
            Required Details for Right of Way (ROW) Permission
          </Typography>
          <Typography sx={{ mb: 1, fontSize: { xs: 14, md: 16 } }} className="gray-800">
            Before starting your application, please keep the following information readily available:
          </Typography>
          <Divider sx={{ borderColor: border, mb: 3 }} />

          {/* Information List */}
          <Box
            component="ul"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              listStyle: "none",
              p: 0,
              m: 0
            }}
          >
            {/* Applicant Information */}
            <Box component="li">
              <Typography className="gray-800" variant="h6" sx={{ fontWeight: "700", fontSize: { xs: "1.1rem", md: "1.25rem" } }}>
                1. Applicant Information
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, pl: 3, m: 0, mt: 0.5 }}>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Applicant Type (Individual/Organization)</Typography>
                </Box>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Applicant/Organization Name</Typography>
                </Box>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Mobile Number</Typography>
                </Box>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Email Address</Typography>
                </Box>
              </Box>
            </Box>

            {/* Utility Information */}
            <Box component="li">
              <Typography className="gray-800" variant="h6" sx={{ fontWeight: "700", fontSize: { xs: "1.1rem", md: "1.25rem" } }}>
                2. Utility Information
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, pl: 3, m: 0, mt: 0.5 }}>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Utility Category (Industrial/Public Utility)</Typography>
                </Box>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Utility Type</Typography>
                </Box>
                <Box component="li" sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                  <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                  <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>Proposed Utility Alignment (Along / Across / Along & Across National Highway)</Typography>
                </Box>
              </Box>
            </Box>

            {/* Location Information */}
            <Box component="li">
              <Typography className="gray-800" variant="h6" sx={{ fontWeight: "700", fontSize: { xs: "1.1rem", md: "1.25rem" } }}>
                3. Location Information
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, pl: 3, m: 0, mt: 0.5 }}>
                {[
                  "National Highway Number",
                  "Highway Authority",
                  "State",
                  "District",
                  "Village/Town",
                  "Taluka/Tehsil (where applicable)",
                  "PIN Code",
                  "Authority Name"
                ].map((item, idx) => (
                  <Box component="li" key={idx} sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                    <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                    <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>{item}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* GIS & Alignment Information */}
            <Box component="li">
              <Typography className="gray-800" variant="h6" sx={{ fontWeight: "700", fontSize: { xs: "1.1rem", md: "1.25rem" } }}>
                4. GIS & Alignment Information
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, pl: 3, m: 0, mt: 0.5 }}>
                {[
                  "Proposed Utility Alignment on GIS Map",
                  "Exact Utility Alignment",
                  "Highway Stretch"
                ].map((item, idx) => (
                  <Box component="li" key={idx} sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                    <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                    <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>{item}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Chainage Information */}
            <Box component="li">
              <Typography className="gray-800" variant="h6" sx={{ fontWeight: "700", fontSize: { xs: "1.1rem", md: "1.25rem" } }}>
                5. Chainage Information
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, pl: 3, m: 0, mt: 0.5 }}>
                {[
                  "Start Chainage",
                  "End Chainage",
                  "Multiple Chainage Details (where applicable)"
                ].map((item, idx) => (
                  <Box component="li" key={idx} sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
                    <Typography className="gray-800" variant="body1" sx={{ fontWeight: 400, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" } }}>•</Typography>
                    <Typography className="gray-800" variant="body1" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>{item}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          {/* Note Box */}
          <Box
            sx={{
              mt: 4,
              p: 2.5,
              borderRadius: 2,
              borderLeft: `4px solid ${border}`
            }}>
            <Typography variant="body1" className="gray-800" sx={{ fontWeight: 500, fontSize: { xs: "1rem", md: "1.1rem" } }}>
              <strong>Note:</strong> Multiple chainage entries are supported within a single ROW application. Applicants should identify the complete utility alignment on the GIS map before proceeding to the next step.
            </Typography>
          </Box>
        </Container>

        <Container
          maxWidth={false}
          disableGutters
          sx={{
            width: "100%",
            maxWidth: "100%",
            px: { xs: 2, md: 6 },
            py: { xs: 2 }
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "700" }}>
            Required Documents For Right of Way (ROW) Permission
          </Typography>
          <Divider sx={{ borderColor: border }} />
          <Grid container spacing={0} sx={{ display: "flex" }}>
            {/* Left column: Categories */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: "100%",
                  borderRight: `1px solid ${border}`,
                  p: 3
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: 20,
                    color: "#212121"
                  }}
                >
                  Sub category
                </Typography>

                <Divider sx={{ mb: 2, borderColor: border }} />

                <Stack spacing={1.5}>
                  {categories.map((c, idx) => {
                    const active = idx === activeIndex;
                    return (
                      <Box
                        key={c.id}
                        onClick={() => setActiveIndex(idx)}
                        sx={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 2,
                          p: "14px 12px",
                          cursor: "pointer",
                          bgcolor: active
                            ? "rgba(58,28,115,0.08)"
                            : "transparent",
                          borderRight: active
                            ? `4px solid ${accent}`
                            : "0px solid transparent",
                          borderRadius: "2px",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            bgcolor: active
                              ? "rgba(58,28,115,0.08)"
                              : "rgba(0,0,0,0.02)"
                          }
                        }}
                      >
                        <Box sx={{ flex: 1, pr: 1 }}>
                          <Typography
                            sx={{
                              fontSize: 14,
                              fontWeight: 700,
                              color: active ? accent : "#333",
                              lineHeight: 1.5
                            }}
                          >
                            {c.title}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            flexShrink: 0,
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            bgcolor: active ? accent : "#D5D5D5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: active ? "#fff" : "#666",
                            fontSize: 11,
                            fontWeight: 700
                          }}
                        >
                          {c.count}
                        </Box>
                      </Box>
                    );
                  })}
                </Stack>
              </Box>
            </Grid>

            {/* Right column: Document List */}
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  bgcolor: "#fff",
                  p: 3
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    mb: 2,
                    fontSize: 20,
                    color: "#212121",
                    lineHeight: 1.4
                  }}
                >
                  {activeCategory.title}
                </Typography>

                <Divider sx={{ my: 2, borderColor: border }} />

                <Typography
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: 13,
                    color: "#212121"
                  }}
                >
                  Documents List
                </Typography>

                <Stack spacing={0}>
                  {activeData.documents.map((doc, i) => (
                    <Box key={i}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          alignItems: "flex-start",
                          py: 1.5
                        }}
                      >
                        <Typography
                          sx={{
                            minWidth: 24,
                            color: subdued,
                            fontWeight: 600,
                            fontSize: 13
                          }}
                        >
                          {i + 1}.
                        </Typography>
                        <Typography
                          sx={{
                            color: "#333",
                            fontSize: 13,
                            lineHeight: 1.6,
                            fontWeight: 400
                          }}
                        >
                          {doc}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Stack>

                <Divider sx={{ my: 2, borderColor: border }} />

                <Typography
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: 13,
                    color: "#212121"
                  }}
                >
                  Drawings List
                </Typography>

                <Stack spacing={0}>
                  {activeData.drawings.map((draw, i) => (
                    <Box key={i}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          alignItems: "flex-start",
                          py: 1.5
                        }}
                      >
                        <Typography
                          sx={{
                            minWidth: 24,
                            color: subdued,
                            fontWeight: 600,
                            fontSize: 13
                          }}
                        >
                          {i + 1}.
                        </Typography>
                        <Typography
                          sx={{
                            color: "#333",
                            fontSize: 13,
                            lineHeight: 1.6,
                            fontWeight: 400
                          }}
                        >
                          {draw}
                        </Typography>
                      </Box>
                      <Divider sx={{ borderColor: border, my: 0 }} />
                    </Box>
                  ))}
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <FooterCommonLogin />
    </>
  );
};

export default DocListRightofWayPermission;
